import { useState } from "react"
import useAxiosInstance from "../../../../../Utilities/Hooks/useAxiosInstance"
import { MANAGE_COLLECTIONS_API } from "../../../../../Utilities/APIs/APIs"
import Form from "../../../../Partials/Layouts/Forms/Form"
import ShortTextInput from "../../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput"
import FormSubmitButton from "../../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton"


function CreateCollections({

    employee, setShowCreateForm, setShowModal, triggerFetch

}) {

    const [name, setName] = useState('')
    const [description, setDescription] = useState('')

    const axiosInstance = useAxiosInstance()

    async function handleSubmit(e) {
        e.preventDefault()
        const itemData = { name, description }

        const response = await axiosInstance.post(MANAGE_COLLECTIONS_API, itemData)

        if (response) {

            setShowCreateForm(false);
            setShowModal(false);
            triggerFetch()
        }

    }

    return (
        <Form onSubmit={handleSubmit} hasImage>
            <ShortTextInput
                label="Name"
                placeholder='Enter name'
                value={name}
                setState={setName}

            />
            <ShortTextInput
                label="Description"
                placeholder='Enter description'
                value={description}
                setState={setDescription}

            />

            <FormSubmitButton text='Create Collection' />
        </Form>
    )
}

export default CreateCollections